import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://winchmohamedbahr.com";
const BRAND = " | ونش انقاذ محمد بحر";

export default function SEO({ title, description, path = "/", image = "/logo.png", jsonLd = null, type = "website", appendBrand = false, noindex = false, nofollow = false }) {
  const robotsParts = [];
  if (noindex) robotsParts.push("noindex");
  else robotsParts.push("index");
  if (nofollow) robotsParts.push("nofollow");
  else robotsParts.push("follow");
  const robots = robotsParts.join(", ");
  const fullTitle = appendBrand && !title.includes("محمد بحر") ? `${title}${BRAND}` : title;
  const url = `${SITE}${path}`;
  const img = image.startsWith("http") ? image : `${SITE}${image}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {noindex && <meta name="robots" content={robots} />}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
      {Array.isArray(jsonLd)
        ? jsonLd.map((schema, idx) => (
            <script key={idx} type="application/ld+json">
              {JSON.stringify(schema)}
            </script>
          ))
        : jsonLd && (
            <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
          )}
    </Helmet>
  );
}
